import { Box } from '@mui/material'
import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Notes(props: Props) {
  const { extOrder } = props
  const texts = useTexts()

  const { notes } = extOrder.orderStep

  return (
    <preview.Field label={texts.notes.label}>
      {notes.length > 0 ? (
        <Box
          component="span"
          sx={{ display: 'block', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
        >
          {notes}
        </Box>
      ) : (
        <preview.NullValue />
      )}
    </preview.Field>
  )
}
